import React, { useState } from 'react';
import * as Images from '../../../assets';
import { fetchWithFormDataToken } from '../../../apiGeneralFunction';
import { toast } from 'react-toastify';

const ContactUsForm = () => {
    const [formData, setFormData] = useState({
        societyName: '',
        address: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        fullName: '',
        email: '',
        password: '',
        mobileNumber: '',
        comments: '',
    });
    const [showForm, setShowForm] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const { societyName, address, country, state, city, pincode, fullName, email, password, mobileNumber, comments } = formData;

        if (!societyName) {
            toast.error("Society Name is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!address) {
            toast.error("Address is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!country) {
            toast.error("Country is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!state) {
            toast.error("State is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!city) {
            toast.error("City is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!pincode) {
            toast.error("Pincode is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!fullName) {
            toast.error("Full Name is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!email) {
            toast.error("Email is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Invalid email format.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!mobileNumber) {
            toast.error("Phone Number is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(mobileNumber)) {
            toast.error("Invalid phone number format. It should be 10 digits.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!password) {
            toast.error("Password is required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (password.length < 8) {
            toast.error("Password must be at least 8 characters long.", { position: 'top-center', autoClose: 2000 });
            return false;
        }
        if (!comments) {
            toast.error("Comments are required.", { position: 'top-center', autoClose: 2000 });
            return false;
        }

        return true;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const abortController = new AbortController();

        try {
            const formdata = new FormData();
            formdata.append("society_name", formData.societyName);
            formdata.append("address", formData.address);
            formdata.append("country", formData.country);
            formdata.append("state", formData.state);
            formdata.append("city", formData.city);
            formdata.append("pin_code", formData.pincode);
            formdata.append("full_name", formData.fullName);
            formdata.append("email", formData.email);
            formdata.append("password", formData.password);
            formdata.append("phone_number", formData.mobileNumber);
            formdata.append("comments", formData.comments);

            console.log("Form Data Submitted:", formData);

            const result = await fetchWithFormDataToken('contact-us', formdata, abortController);

            if (result?.status === true) {
                toast.success(result?.message || "Form submitted successfully.", {
                    position: 'top-center',
                    autoClose: 2000,
                });

                // Reset the form data after successful submission
                setFormData({
                    societyName: '',
                    address: '',
                    country: '',
                    state: '',
                    city: '',
                    pincode: '',
                    fullName: '',
                    email: '',
                    password: '',
                    mobileNumber: '',
                    comments: '',
                });
            } else {
                toast.error(result?.message || "Submission failed.", {
                    position: 'top-center',
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An error occurred while submitting the form.", {
                position: 'top-center',
                autoClose: 2000,
            });
        } finally {
            abortController.abort();
        }
    };

    return (
        <section id='contact2'>
            <div className="container mx-auto p-4">
                <hr />
                {showForm && (
                    <h1 className="font-bold text-3xl text-center mt-5"> Register With Us </h1>
                )}
                <p className="text-center text-lg mt-5">
                    India’s leading ad-free housing society software – Superior product, superior support
                </p>
                {!showForm && (
                    <h1 className="font-bold text-lg">
                        <div className="text-center mt-5">
                            <button
                                onClick={() => setShowForm(true)}
                                className="about-us-btn text-white px-4 py-2 rounded"
                            >
                                Register With Us <i className="fas fa-chevron-down ml-2"></i>
                            </button>
                        </div>
                    </h1>
                )}



                {showForm && (
                    <div className="mt-5">
                        <form onSubmit={handleFormSubmit} className="bg-white p-6 rounded shadow-all-sides gap-4">
                            <div className="space-y-2">
                                {/* Society Name */}
                                <div>
                                    <label htmlFor="societyName" className="block text-sm font-medium mb-2">Society Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        id="societyName"
                                        name="societyName"
                                        placeholder="Enter Society Name"
                                        value={formData.societyName}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>

                                {/* Society Address */}
                                <div>
                                    <label htmlFor="address" className="block text-sm font-medium mb-2">Society Address <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        placeholder="Enter Society Address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                    />
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium mb-2">
                                            Full Name <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="fullName"
                                            value={formData.fullName}
                                            placeholder="Enter Your Full Name"
                                            onChange={handleChange}
                                            required
                                            className="w-full p-2 border border-gray-300 rounded"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="mobileNumber" className="block text-sm font-medium mb-2">Mobile Number <span className="text-red-500">*</span></label>
                                        <input
                                            type="tel"
                                            id="mobileNumber"
                                            name="mobileNumber"
                                            placeholder="Enter Mobile Number"
                                            value={formData.mobileNumber}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>

                                {/* City and Pincode */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="city" className="block text-sm font-medium mb-2">City <span className="text-red-500">*</span></label>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            placeholder="Enter City"
                                            value={formData.city}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="pincode" className="block text-sm font-medium mb-2">Pincode <span className="text-red-500">*</span></label>
                                        <input
                                            type="number"
                                            id="pincode"
                                            name="pincode"
                                            placeholder="Enter Pincode"
                                            value={formData.pincode}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>

                                {/* State and Country */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="state" className="block text-sm font-medium mb-2">State <span className="text-red-500">*</span></label>
                                        <input
                                            type="text"
                                            id="state"
                                            name="state"
                                            placeholder="Enter State"
                                            value={formData.state}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="country" className="block text-sm font-medium mb-2">Country <span className="text-red-500">*</span></label>
                                        <input
                                            type="text"
                                            id="country"
                                            name="country"
                                            placeholder="Enter Country"
                                            value={formData.country}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>

                                {/* Mobile Number and Email */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium mb-2">Email <span className="text-red-500">*</span></label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            placeholder="Enter Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="password" className="block text-sm font-medium mb-2">Password <span className="text-red-500">*</span></label>
                                        <input
                                            type="password"
                                            id="password"
                                            name="password"
                                            placeholder="Enter Password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>

                                {/* comments */}
                                <div>
                                    <label htmlFor="comments" className="block text-sm font-medium mb-2">Comments <span className="text-red-500">*</span></label>
                                    <textarea
                                        id="comments"
                                        name="comments"
                                        placeholder="Enter comments"
                                        value={formData.comments}
                                        onChange={handleChange}
                                        rows="3"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        style={{ height: '100px', resize: 'none' }}
                                    />
                                </div>

                                {/* Submit Button */}
                                <div className="flex justify-center">
                                    <button
                                        type="submit"
                                        className="px-6 py-3 about-us-btn text-white font-medium rounded-md hover:about-us-btn focus:outline-none focus:ring-2 focus:ring-offset-2"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ContactUsForm;